import { CButton, CButtonGroup, CSpinner } from '@coreui/react'
import React, { useEffect } from 'react'
import { CopySvg, MoveToSvg, TrashSVG, UserBlockSvg } from '../../../../../../components/IconSvg'
import { IContact } from '../../../../../../service/interfaces/contacts'
import PhonebookModal from './phonebookModal'
import CustomValuesHook from '../../../../../../Hooks/customValuesHook'
import { useDispatch } from 'react-redux'
import { ContactListToBlockRequestAction, removeContactRequestAction, removeFromPhoneBookContactRequestAction, resetContactPropsAction } from '../../../../../../service/actions/contactActions'
import { useSelector } from 'react-redux'
import CustomModal from '../../../../../../components/CroreUIModal'
import { removeFromPhoneBookContactPayloadType } from '../../../../../../service/types/contacts/apiRequestTypes'


const StackTools = ({ selectedList, isGetMargin = false }: { selectedList: IContact[], isGetMargin: boolean }) => {
    const [states, setSates] = CustomValuesHook({ display: false, operationType: '', displayRemoveConfirm: false })
    const deletePending = useSelector((state: any) => state.contactReducer.removeFromPhoneBookContactPending)
    const deleteSuccess = useSelector((state: any) => state.contactReducer.removeFromPhoneBookContactSuccess)

    const blockPending = useSelector((state: any) => state.contactReducer.contactListToBlockPending)

    const dispatch = useDispatch()

    useEffect(() => {

        if (deleteSuccess) {
            setSates({
                displayRemoveConfirm: false
            })
            dispatch(resetContactPropsAction())
        }
    }, [deleteSuccess])
    const handleDeleteContacts = () => {
        if (selectedList.length > 0) {
            setSates({
                displayRemoveConfirm: true
            })
        }

    }

    const handleBlockContacts = () => {
        if (selectedList.length > 0) {
            dispatch(ContactListToBlockRequestAction({
                isInBlackList: true,
                contacts: selectedList.map((item: IContact) => item.contactId)
            }))
        }

    }

    const footerComponent = () => {

        return (<div className='d-flex justify-content-end'>
            <button className='btn btn-default mx-2' onClick={() => setSates({
                displayRemoveConfirm: false
            })} >انصراف</button>
            <button className='btn btn-primary'
                disabled={deletePending}
                onClick={() => {
                    const paramsList: removeFromPhoneBookContactPayloadType[] = [];
                    selectedList.forEach((item: IContact) => {
                        const tempModel: removeFromPhoneBookContactPayloadType = { phoneBookId: item.phoneBookId, contactId: item.contactId }
                        paramsList.push(tempModel)
                    })


                    dispatch(removeFromPhoneBookContactRequestAction(paramsList))



                }}>تایید</button>
        </div >)
    }

    return (
        <>
            <div className={`stack-tools d-flex justify-content-end pe-5 pb-5 ${isGetMargin ? 'get-margin' : ''}`}>
                {selectedList.length > 0 && < CButtonGroup role="group" aria-label="Basic mixed styles example">
                    <CButton color="success"
                        onClick={() => {
                            if (selectedList.length > 0) {
                                setSates({ display: true, operationType: 'copy' })

                            }
                        }}>
                        کپی
                        <span className='mx-1'>
                            <CopySvg width={15} height={15} fill='#ffffff' />
                        </span>
                    </CButton>
                    <CButton color="primary"
                        onClick={() => {
                            if (selectedList.length > 0) {
                                setSates({ display: true, operationType: 'move' })
                            }
                        }}>انتقال
                        <span className='mx-1'>
                            <MoveToSvg width={15} height={15} fill='#ffffff' />
                        </span>
                    </CButton>
                    <CButton color="danger"
                        disabled={deletePending}
                        onClick={handleDeleteContacts}
                    >حذف
                        {deletePending ? <CSpinner size="sm" /> : <span className='mx-1'>
                            <TrashSVG width={15} height={15} fill='#ffffff' />
                        </span>}

                    </CButton>
                    {/* <CButton color="warning"
                        disabled={blockPending}
                        onClick={handleBlockContacts}
                    >مسدود
                        {blockPending ? <CSpinner size="sm" /> : <span className='mx-1'>
                            <UserBlockSvg width={15} height={15} fill='#ffffff' />
                        </span>}

                    </CButton> */}
                </CButtonGroup>}

            </div >
            <PhonebookModal
                display={states.display}
                setDisplay={() => setSates({ display: false })}
                selectedList={selectedList}
                operationType={states.operationType} />

            <CustomModal
                setShow={() => setSates({
                    displayRemoveConfirm: false,
                })}
                title={() => {
                    return (<div style={{ fontSize: '14px' }}>تایید حذف مخاطبین</div>)
                }}
                component={() => <div>آیا از عملیات حذف اطمینان دارید؟</div>}
                show={states.displayRemoveConfirm}
                footerComponent={footerComponent}
                size={'sm'}
                backdrop={true}
            />
        </>

    )
}

export default StackTools